import { InputNumber } from "antd";

const CompleteProfileStep5 = ({ yearsExperience, setYearsExperience }) => {
  return (<div className="CompleteProfileForm">
    <label>Years Experience</label>
    <InputNumber style={{ width: '100%' }} value={yearsExperience} onChange={setYearsExperience} size="large" />
  </div>)
}

export default CompleteProfileStep5;